import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Will this add to my workload?',
      answer: 'Vetuvia is designed to fit around your existing schedule. You control your availability, rates, and service offerings. Many veterinarians start with just a few hours per week and scale as they build their client base.',
    },
    {
      question: 'Is Vetuvia compliant with veterinary regulations?',
      answer: 'Yes. Vetuvia is built with veterinary compliance in mind. We support VCPR requirements, state-specific telemedicine regulations, and provide documentation tools to help you maintain proper records. You remain responsible for following your state board guidelines.',
    },
    {
      question: 'How hard is it to set up?',
      answer: 'Most veterinarians complete their profile setup in under 30 minutes. We provide step-by-step guidance, templates for service descriptions, and support throughout the onboarding process. You can launch your first service within a day.',
    },
    {
      question: 'Who is Vetuvia for?',
      answer: 'Vetuvia is for employed veterinarians, relief vets, and independent-minded DVMs who want to increase their income and build long-term client relationships without the overhead of opening a full clinic. Whether you\'re looking to supplement your salary or transition to independence, Vetuvia provides the infrastructure.',
    },
    {
      question: 'Can I use Vetuvia if I\'m employed full-time?',
      answer: 'Absolutely. Many of our veterinarians are employed full-time and use Vetuvia to build additional income streams during evenings, weekends, or days off. Check your employment agreement for any restrictions, but most allow outside consulting work.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 lg:py-32 bg-[#F4F7FB]">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4] mb-4 block">
            Frequently Asked Questions
          </span>
          <h2 className="text-4xl lg:text-5xl font-serif text-gray-900">
            Everything You Need to Know
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <div className="flex-shrink-0">
                  <i
                    className={`${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    } text-2xl text-[#4DB8D4] transition-transform`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6 pt-2">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
